import { getClass, getClassOrSymbol } from '../utils/object-utils.js';
import { ProxyMap } from './proxy-map.js';

/**
 * Registry，是一个特定类型值的注册集合
 * @public
 */
class Registry extends ProxyMap {
    constructor(klass) {
        super();
        this.klass = klass;
        this.klass = getClass(this.klass);
    }
    createIfNotExists(key) {
        if (!this.has(key)) {
            const item = new this.klass(key);
            this.set(key, item);
        }
        return this.get(key);
    }
    merge(target, options) {
        const meta = this.createIfNotExists(target);
        Object.keys(options).forEach((key) => {
            meta[key] = options[key];
        });
        this.set(target, meta);
    }
    get(key) {
        return this.map.get(getClassOrSymbol(key));
    }
    has(key) {
        return this.map.has(getClassOrSymbol(key));
    }
    set(key, metadata) {
        this.map.set(getClassOrSymbol(key), metadata);
        return this;
    }
    delete(key) {
        const result = this.map.delete(getClassOrSymbol(key));
        return result;
    }
}

export { Registry };
//# sourceMappingURL=registry.js.map
